import { useEffect, useState } from "react";

const HOUR = 3600000;

/** Live remaining ms until `target` (negative once passed); ticks every second. */
export default function useCountdown(target) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!target) return undefined;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [target]);
  return target ? target - now : null;
}

const DAY = 24 * HOUR;
const pad = (n) => String(n).padStart(2, "0");

/** Largest unit only: "2d", "20h", "12m". The full ticking string stays beside it. */
export const compactLeft = (ms) => {
  const abs = Math.abs(ms || 0);
  const d = Math.floor(abs / DAY);
  const h = Math.floor((abs % DAY) / HOUR);
  const m = Math.floor((abs % HOUR) / 60000);
  if (d > 0) return `${d}d`;
  if (h > 0) return `${h}h`;
  if (m > 0) return `${m}m`;
  return "0m";
};

/**
 * How much of the created→due window is still ahead, 0–1.
 * Once the deadline has passed the ring stays full, in the late color.
 */
export const ringRemainRatio = (createdAt, dueAt, now) => {
  if (!dueAt || now >= dueAt) return 1;
  if (!createdAt || dueAt <= createdAt) return 1;
  return Math.max(0, Math.min(1, (dueAt - now) / (dueAt - createdAt)));
};

/** "2d 04h", "3h 12m 05s", "12m 05s" — seconds only once it gets tight. */
export const formatCountdown = (ms) => {
  const abs = Math.abs(ms);
  const d = Math.floor(abs / (24 * HOUR));
  const h = Math.floor((abs % (24 * HOUR)) / HOUR);
  const m = Math.floor((abs % HOUR) / 60000);
  const s = Math.floor((abs % 60000) / 1000);
  if (d > 0) return `${d}d ${pad(h)}h ${pad(m)}m`;
  if (h > 0) return `${h}h ${pad(m)}m ${pad(s)}s`;
  return `${m}m ${pad(s)}s`;
};
